import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { IconColor, IconType, IconSize } from '../../../common/constants';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-tooltip-alert',
  imports: [IntrackFeatureModule, MatTooltipModule, SvgIconComponent],
  templateUrl: './tooltip-alert.component.html',
  styleUrls: ['./tooltip-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipAlertComponent {
  @Input() tooltipText: string;
  @Input() tooltipPosition: TooltipPosition = 'above';
  @Input() iconType: IconType = IconType.AlertWarningFilled;
  @Input() iconSize: IconSize = IconSize.Small;
  @Input() iconColor: IconColor = IconColor.Yellow;
  iconColorsMap: Record<IconColor, 'tw-text-black' | 'tw-text-yellow-500'> = {
    [IconColor.Black]: 'tw-text-black',
    [IconColor.Yellow]: 'tw-text-yellow-500',
  };
  iconSizesMap: Record<IconSize, 14 | 16 | 20> = {
    [IconSize.Small]: 14,
    [IconSize.Medium]: 16,
    [IconSize.Large]: 20,
  };
}
